import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HotelsListComponent } from './hotels-list.component';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { RouterModule } from '@angular/router';
import { HotelModule } from './hotel';

@NgModule({
    declarations: [HotelsListComponent],
    exports: [HotelsListComponent],
    imports: [CommonModule, RouterModule, HotelModule, TranslateModule.forChild(), LocalizeRouterModule.forChild([])],
    providers: []
})
export class HotelsListModule {}
